// extracted by mini-css-extract-plugin
export var alternate = "_1f-h";
export var black = "_1f-3";
export var blue = "_1f-d";
export var blueLight = "_1f-c";
export var brand = "_1f-7";
export var error = "_1f-9";
export var gray = "_1f-6";
export var grayBlue = "_1f-b";
export var iconWrapper = "_1f-4";
export var indigo = "_1f-e";
export var orange = "_1f-g";
export var pink = "_1f-f";
export var primary = "_1f-0";
export var purple = "_1f-8";
export var success = "_1f-5";
export var warning = "_1f-a";
export var white = "_1f-1";
export var whiteSuccess = "_1f-2";